import * as CopyToClipboard from "react-copy-to-clipboard"
import * as React from "react"
import { connect } from "react-redux"

import { Action, ActionType } from "@tenforce/toolbox-button-push-react"
import { Modal } from "@tenforce/toolbox-modal-react"

import { mapDispatchToProps, DispatchProps } from "../../actions"
import { GlobalState } from "../../../../store"
import OldUIContext from "../../../../olduicontext"

import { Symbols } from "@tenforce/toolbox-fontmap"
import env from "../../../../env"
import { Labels } from "../../../../util/Translations"

type StateProps = ResourceHeader.Header

type Props = StateProps & DispatchProps

export class ShareButton extends React.PureComponent<Props> {
    static contextType = OldUIContext
    context: React.ContextType<typeof OldUIContext>

    render(): JSX.Element {
        const {
            headerTypes,
            unsyncTitle,
            itemData,
            shareSuccessMessageVisible,
            updateShareSuccessMessageVisibility,
        } = this.props
        const url = `${window.location.origin}${window.location.pathname}`

        if (
            headerTypes.contains("Settings") ||
            headerTypes.contains("Dashboard") ||
            headerTypes.contains("Workspace") ||
            window.location.pathname
                .replace(env.applicationPath, "")
                .includes("timesheet")
        ) {
            return <></>
        }

        const { ShareButtonTooltip } = Labels

        const itemNumber = itemData?.number

        const numberText =
            !!itemNumber?.value && !itemNumber?.hidden
                ? `(${itemNumber?.value}) `
                : ""

        const text = `${numberText}${unsyncTitle} - ${url}`

        return (
            <>
                <CopyToClipboard
                    text={text}
                    onCopy={(): void => {
                        updateShareSuccessMessageVisibility(true)
                    }}
                    options={{ format: "text/plain" }}
                >
                    <Action
                        title={ShareButtonTooltip}
                        id="shareButton"
                        data-ft-number={itemNumber?.value ?? ""}
                        data-ft-title={unsyncTitle}
                        data-ft-url={url}
                        actionType={ActionType.icon}
                    >
                        {Symbols.CopyToClipboard}
                    </Action>
                </CopyToClipboard>
                <Modal
                    isShown={shareSuccessMessageVisible}
                    containerProps={{
                        id: "shareSuccessMessageModal",
                        targetSelector: "#shareButton",
                        onClose: (): void => {
                            updateShareSuccessMessageVisibility(false)
                        },
                    }}
                >
                    <div className="theme-bubble theme-settings animate-movebgstripes tw-w-fit tw-px-3 tw-py-1">
                        <p>{this.getShareSuccessMesage()}</p>
                    </div>
                </Modal>
            </>
        )
    }

    getShareSuccessMesage = (): string => {
        const {
            ItemDetailsCopiedToClipboard,
            CollectionDetailsCopiedToClipboard,
        } = Labels

        const { headerTypes } = this.props

        if (headerTypes.contains("Smartlist") || headerTypes.contains("List")) {
            return CollectionDetailsCopiedToClipboard
        }

        return ItemDetailsCopiedToClipboard
    }
}

const mapStateToProps = (state: GlobalState): StateProps => state.resourceHeader

export default connect(mapStateToProps, mapDispatchToProps)(ShareButton)
